import React from 'react';

import { inject } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';

import classNames from 'classnames';

// import {Svg} from '../shared';

import { minWidth } from '../../helpers/media-queries';

const styles = ({ palette }) => ({
  root: {
    position: 'absolute',
    top: '5.25vw',
    left: '21vw',
    right: '5.5vw',
    height: '12.75vw',
    fontSize: '10vw',

    zIndex: 1,

    backgroundPosition: 'center',
    backgroundSize: '20px',
    backgroundRepeat: 'repeat',
    fontFamily: "'zx_spectrum7_boldregular', sans",

    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    textAlign: 'center',

    color: '#defaff',
    textStroke: '1px #017287',
    textShadow: `
            0 0 50px #defaff
        `,

    textTransform: 'uppercase',

    backgroundImage: 'url(./static/images/game/grid.png)',

    '&.icons': {
      backgroundImage: `
                url(./static/images/game/icons.png),
                url(./static/images/game/grid.png)
            `,
      backgroundPosition: `
                center center, 
                center center
            `,
      backgroundSize: `
                contain, 
                10px 20px
            `,
      backgroundRepeat: `
                no-repeat, 
                repeat
            `,
      fontSize: '0em',
    },

    '&.score': {
      backgroundImage: `
                url(./static/images/game/trophy.png), 
                url(./static/images/game/trophy.png), 
                url(./static/images/game/grid.png)
            `,
      backgroundPosition: `
                center left, 
                center right, 
                center center
            `,
      backgroundSize: `
                auto 80%, 
                auto 80%,  
                10px 20px
            `,
      backgroundRepeat: `
                no-repeat, 
                no-repeat, 
                repeat
            `,
    },

    [minWidth.lg]: {
      height: '138px',
      left: '230px',
      right: '50px',
      top: '57px',
      fontSize: '100px',
    },
  },

  fx: {
    zIndex: 1,
    position: 'absolute',
    top: '5.25vw',
    left: '5vw',
    right: '14vw',
    width: '12.75vw',
    height: '12.75vw',
    fontSize: 0,

    userSelect: 'none',

    padding: '0 !important',

    border: 'none',
    cursor: 'pointer',
    display: 'block',

    backgroundColor: 'transparent',
    backgroundImage: 'url(./static/images/game/logo-fox.png)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'auto 12.75vw',
    backgroundPosition: 'left top',

    [minWidth.lg]: {
      width: '138px',
      height: '138px',
      left: '50px',
      top: '57px',
      backgroundSize: 'auto 138px',
    },

    '&:active': {
      backgroundPosition: 'right top',
    },
  },
});

const mapper = (stores, props) => ({
  intl: stores.intl.dictionary,
  score: stores.user.score,
  name: stores.user._user,
});

class GameHeader extends React.Component {
  state = {
    status: false,
  };

  render() {
    const { score, name, intl, classes } = this.props;
    let status = this.state.status;

    if (!score) status = false;

    return (
      <React.Fragment>
        <a
          className={classNames(classes.fx)}
          alt={intl['LOCALE.FX.LABEL']}
          title={intl['LOCALE.FX.LABEL']}
          href={intl['LOCALE.FX.URL']}
          target="_BLANK"
        >
          {intl['LOCALE.FX.LABEL']}
        </a>
        <aside
          className={classNames(classes.root, {
            icons: !score,
            score: status && !!score,
          })}
        >
          {status ? `${name} ${score}` : intl['LOCALE.GAME.BEST_SCORE']}
        </aside>
      </React.Fragment>
    );
  }

  componentDidMount() {
    this._toogle();
  }

  _toogle() {
    this.setState({ status: !this.state.status });
    setTimeout(() => {
      this._toogle();
    }, 2000);
  }
}

export default inject(mapper)(withStyles(styles)(GameHeader));
